<div class="page-breadcrumb d-none d-sm-flex align-items-center mb-3">
    <div class="ps-3">
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb mb-0 p-0">
                <li class="breadcrumb-item"><a href="javascript:;"><i class="bx bx-home-alt"></i></a>
                </li>
                <li class="breadcrumb-item active" aria-current="page">STRATEGIES</li>
            </ol>
        </nav>
    </div>
    <div class="ms-auto">
        <div class="btn-group">
            <button type="button" class="btn btn-primary" *ngIf="admin == 'true'" (click)="onAdd()">ADD STRATEGY</button>
        </div>
    </div>
</div>
<div class="card">
    <div class="card-body">
        <div class="d-flex align-items-center">
            <h5 class="mb-0"></h5>
            <form class="ms-auto position-relative">
                <div class="position-absolute top-50 translate-middle-y search-icon px-3"><i class="bi bi-search"></i></div>
                <input class="form-control ps-5" type="text" placeholder="search">
            </form>
        </div>
        <div class="table-responsive mt-3">
            <table class="table align-middle">
                <thead class="table-secondary">
                    <tr>
                        <th class="text-center">NAME</th>
                        <th class="text-center">DISPLAY NAME</th>
                        <th class="text-center">TYPE</th>
                        <th class="text-center">CONFIG</th>
                        <th class="text-center">SCRIPT</th>
                        <th class="text-center">ACTIONS</th>
                        <th class="text-center">PUBLIC</th>
                        <th class="text-center">STATUS</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let strategy of strategies">
                        <td class="text-center">
                            {{ strategy.name }}
                        </td>
                        <td class="text-center">{{ strategy.display_name }}</td>
                        <td class="text-center">{{ strategy.type.toUpperCase() }}</td>
                        <td class="text-center">
                            <div><strong>Buy</strong> {{ strategy.config?.capital?.buy }}</div>
                            <div><strong>Sell</strong> {{ strategy.config?.capital?.sell }}</div>
                        </td>
                        <td class="text-center">{{ strategy.script.toUpperCase() }}</td>
                        <td class="text-center">
                            <div class="table-actions d-flex justify-content-center align-items-center gap-2 fs-6">
                                <i class="bi bi-pencil-fill pencil text-primary" (click)="onUpdate(strategy)"></i>
                            </div>
                        </td>
                        <td class="text-center">
                            <div class="form-check form-switch form-check-reverse d-flex justify-content-center">
                                <input class="form-check-input" type="checkbox" id="listSwitch" [checked]="strategy.scope == 'public'" (click)="onScopeClick($event, strategy)">
                                <label class="form-check-label" for="listSwitch"></label>
                            </div>
                        </td>
                        <td class="text-center">
                            <div class="form-check form-switch form-check-reverse d-flex justify-content-center">
                                <input class="form-check-input" type="checkbox" id="listSwitch" [checked]="strategy.state == 'active'" (click)="onStatusClick($event, strategy)">
                                <label class="form-check-label" for="listSwitch"></label>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>
<nav aria-label="Page navigation example" class="pagination" *ngIf="totalItems > 0">
    <ul class="pagination">
        <li class="page-item" (click)="prev()"><a class="page-link" href="javascript:;">Previous</a>
        </li>
        <li class="page-item" *ngIf="pageNumber < 10"><a class="page-link" href="javascript:;">{{pageNumber + 1}}</a>
        </li>
        <li class="page-item" (click)="next()"><a class="page-link" href="javascript:;">Next</a>
        </li>
    </ul>
</nav>
<div class="modal fade" data-backdrop="static" data-keyboard="false" id="strategyModal" tabindex="-1" role="dialog" aria-labelledby="strategyModalabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="strategyModalLabel">{{ modal_strategy.header }}</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="onModalClose('strategy')"></button>
            </div>
            <div class="form modal-body" [formGroup]="strategy_modal_form">
                <div class="row">
                    <div class="col-md-6">
                        <label class="form-label">Name</label>
                        <div class="form-group">
                            <input type="text" class="form-control" [class.invalid]="name.invalid && name.touched" formControlName="name" />
                            <div *ngIf="name.errors && name.invalid && name.touched">
                                <small class="text-danger" *ngIf="name_errors['required']">Name is required</small>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <label class="form-label">Display Name</label>
                        <div class="form-group">
                            <input type="text" autocomplete="off" class="form-control" [class.is-invalid]="display_name.invalid && display_name.touched" required formControlName="display_name" />
                            <div *ngIf="display_name.errors && display_name.invalid && display_name.touched">
                                <small class="text-danger" *ngIf="display_name_errors['required']">Display Name is required</small>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row" style="margin-top: 2%;">
                    <div class="col-md-6">
                        <label class="form-label">Type</label>
                        <div class="form-group">
                            <input type="text" autocomplete="off" class="form-control" [class.is-invalid]="strategy_type.invalid && strategy_type.touched" required formControlName="strategy_type" />
                            <div *ngIf="strategy_type.errors && strategy_type.invalid && strategy_type.touched">
                                <small class="text-danger" *ngIf="strategy_type_errors['required']">Type is required</small>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <label class="form-label">Script</label>
                        <select class="form-select" [compareWith]="compareScript" formControlName="script" [ngModelOptions]="{standalone: true}">
              <option *ngFor="let script_type of script_types" [value]="script_type._id"> {{ script_type.name }}</option>
            </select>
                    </div>
                </div>
                <div class="row" style="margin-top: 2%;">
                    <div class="col-md-6">
                        <label class="form-label">Buy Capital</label>
                        <div class="form-group">
                            <input type="number" min="1" autocomplete="off" class="form-control" [class.is-invalid]="config_capital_buy.invalid && config_capital_buy.touched" required formControlName="config_capital_buy" />
                            <div *ngIf="config_capital_buy.errors && config_capital_buy.invalid && config_capital_buy.touched">
                                <small class="text-danger" *ngIf="config_capital_buy_errors['required']">Buy Capital is required</small>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <label class="form-label">Sell Capital</label>
                        <div class="form-group">
                            <input type="number" min="1" autocomplete="off" class="form-control" [class.is-invalid]="config_capital_sell.invalid && config_capital_sell.touched" required formControlName="config_capital_sell" />
                            <div *ngIf="config_capital_sell.errors && config_capital_sell.invalid && config_capital_sell.touched">
                                <small class="text-danger" *ngIf="config_capital_sell_errors['required']">Sell Capital is required</small>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button class="btn btn-danger btn-block" data-dismiss="modal" (click)="onModalClose('account')">
          CANCEL
        </button>
                <button class="btn btn-primary" (click)="saveStrategy()" [disabled]="strategy_modal_form.invalid">
          {{ modal_strategy.btn_text }}
        </button>
            </div>
        </div>
    </div>
</div>
<div class="modal fade" id="confirmationStrategyDeleteModal" tabindex="-1" role="dialog" aria-labelledby="confirmationModallabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="confirmationModalLabel">ALERT</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="onModalClose('confirmation_strategy_delete')"></button>
            </div>
            <div class="modal-body px-5">
                <div class="row">
                    <div class="col-md-12">
                        <span class="fs-15"> {{ cm_params.msg }}
              <b>{{ cm_params.tag }}</b></span>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button class="btn btn-primary btn-block" data-dismiss="modal" (click)="onModalClose('confirmation_strategy_delete')">
          CANCEL
        </button>
                <button class="btn btn-danger btn-block" [ngClass]="cm_params.btn_class" (click)="onConfirm()">
          {{ cm_params.btn_text }}
        </button>
            </div>
        </div>
    </div>
</div>
<div id="strategyConfirmationModal" class="modal fade" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">CONFIRMATION</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="updateStrategyStatus(0, confirmationParams)"></button>
            </div>
            <div class="modal-body">
                <p>{{ confirmationParams.message }}</p>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" (click)="updateStrategyStatus(0, confirmationParams)">Close</button>
                <button type="button" class="btn" [ngClass]="confirmationParams.action_class" (click)="updateStrategyStatus(1, confirmationParams)">{{ confirmationParams.action }}</button>
            </div>
        </div>
    </div>
</div>